import React from 'react';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import useSyncPromise from '../../utils/react/useSyncPromise';
import fetchUser from '../../utils/gaia/fetchUser';
import gettext from '../../utils/django/gettext';

function useIsVisible() {
    const [user] = useSyncPromise(fetchUser());
    return user && user.hasSubscription;
}

const sharedProps = {
    href: 'https://help.gaiagps.com/',
    rel: 'noopener noreferrer',
    target: '_blank',
    children: gettext('Help'),
};

function Toolbar(props: React.HTMLProps<HTMLAnchorElement>) {
    if (!useIsVisible()) return null;
    return <a {...props} {...sharedProps} />;
}

function HamburgerMenu(props: MenuItemAnchorProps) {
    if (!useIsVisible()) return null;
    return <MenuItemAnchor {...props} {...sharedProps} />;
}

export default {Toolbar, HamburgerMenu};
